import { gql } from '@apollo/client';

export const FREE_TEXT_LOCATION = gql`
  query freeTextLocationSearch($locationText: String!) {
    freeTextLocationSearch(locationText: $locationText, maxResults: 10) {
      Results {
        Place {
          Geometry {
            Point
          }
          Label
          Region
        }
      }
    }
  }
`;

export const OQ_LANIDS = gql`
  query getLanIdsByOperatorQualificationId($oqId: String!) {
    getLanIdsByOperatorQualificationId(oqId: $oqId) {
      emp_lan_id
    }
  }
`;

export const WORKLOG_ID_DETAILS = gql`
  query getWorklogById($id: String!) {
    getWorklogById(id: $id) {
      doc_type
      metadata_originating_user
      metadata_user
      id
      start_time
      start_latitude
      start_longitude
      locator
      end_time
      end_latitude
      end_longitude
      response_type
      long_description
      note
      form
      photos {
        is_legacy
        original
        original_download_url
        thumbnail
        thumbnail_download_url
      }
      positiveResponse {
        id
        contact_flow_id
        destination_phone_number
        instance_id
        source_phone_number
        contact_result
        contact_type
        email_body
        email_status
        email_subject
        email_to
        metadata_date
        ticket_id
        trigger_doc_id
        message
      }
    }
  }
`;

export const GET_WORKLOGS_BY_ID = gql`
  query getWorklogsById($ids: [String]!) {
    getWorklogsById(ids: $ids) {
      doc_type
      id
      ticket_id
      start_time
      start_latitude
      start_longitude
      end_time
      end_latitude
      end_longitude
      response_additional_comments
      response_scada
      response_type
      related_field_meet_id
      related_ticket_id
    }
  }
`;
export const GET_TICKETS_BY_ID = gql`
  query getTicketsById($ids: [String]!) {
    getTicketsById(ids: $ids) {
      id
      pge_address
      pge_folder
      pge_status
      pge_work_date
      priority
      response_due
    }
  }
`;
export const GET_FIELDMEETS_BY_ID = gql`
  query getFieldMeetsById($ids: [String]!) {
    getFieldMeetsById(ids: $ids) {
      id
      pge_folder
      parent {
        pge_address
        priority
        response_due
      }
    }
  }
`;
export const GET_STANDBYS_BY_ID = gql`
  query getStandBysById($ids: [String]!) {
    getStandBysById(ids: $ids) {
      id
      pge_folder
      parent {
        pge_address
        priority
        response_due
      }
    }
  }
`;

export const WORKLOG_PHOTOS = gql`
  query getWorklogById($id: String!) {
    getWorklogById(id: $id) {
      photos {
        is_legacy
        original
        original_download_url
        thumbnail_download_url
      }
    }
  }
`;

export const SHORT_TICKET_ID = gql`
  query getTicketByShortId($id: String!) {
    getTicketByShortId(id: $id) {
      id
    }
  }
`;

export const LOOKUP_TICKET_ID = gql`
  query getTicketByShortId($id: String!) {
    getTicketByShortId(id: $id, restricted: true) {
      id
      created
      doc_type
      legacy_ticket
      place
      pge_address
      pge_division
      pge_folder
      pge_excavator
      pge_work_date
      pge_reg_code
      pge_status
      printable_text
      priority
      type
      transmitted
      pge_reg_code
      work_type
      worklogs {
        doc_type
        metadata_originating_user
        metadata_user
        id
        start_time
        start_latitude
        start_longitude
        locator
        end_time
        end_latitude
        end_longitude
        response_type
        long_description
        note
        form
        worklog_type
        response_type
        photos {
          is_legacy
          original
          original_download_url
          thumbnail
          thumbnail_download_url
        }
        positiveResponse {
          id
          contact_flow_id
          destination_phone_number
          instance_id
          source_phone_number
          contact_result
          contact_type
          email_body
          email_status
          email_subject
          email_to
          metadata_date
          ticket_id
          trigger_doc_id
          message
        }
      }
    }
  }
`;

//   variables: { id: ticketID },
//"A182150426-11-PGETOP-2019-05-10"

export const TICKET_ID_DETAILS = gql`
  query getTicketById($id: String!) {
    getTicketById(id: $id) {
      id
      location
      place
      pge_center_coords {
        coordinates
      }
      priority
      doc_type
      pge_address
      pge_division
      pge_folder
      pge_status
      pge_excavator
      pge_work_date
      pge_work_date_formatted
      work_type
      type
      fieldMeets {
        id
      }
      standbys {
        id
      }
      predictions
      printable_text
      pge_polygon {
        coordinates
      }
      legacy_ticket
      worklogs {
        doc_type
        adjusted_start
        metadata_backend_state
        metadata_client_name
        metadata_client_version
        metadata_date
        metadata_first_processed_date
        metadata_originating_user
        metadata_triggering_document_id
        metadata_latitude
        metadata_longitude
        metadata_user
        id
        ticket_id
        is_legacy
        start_time
        start_latitude
        start_longitude
        locator
        end_time
        end_latitude
        end_longitude
        response_additional_comments
        response_scada
        response_type
        legacy_audit
        long_description
        note
        related_field_meet_id
        related_ticket_id
        legacy_attachments
        standby_id
        field_meet_id
        worklog_type
        source_file_path
        form
        hookup_points
        positiveResponse {
          id
          contact_flow_id
          destination_phone_number
          instance_id
          source_phone_number
          contact_result
          contact_type
          email_body
          email_status
          email_subject
          email_to
          metadata_date
          ticket_id
          trigger_doc_id
          message
        }
        photos {
          is_legacy
          original
          original_download_url
          thumbnail_download_url
        }
      }
    }
  }
`;
//   variables: { id: ticketID },
//"A182150426-11-PGETOP-2019-05-10"

export const FIELDMEET_ID_DETAILS = gql`
  query getFieldMeetById($id: String!) {
    getFieldMeetById(id: $id) {
      doc_type
      id
      metadata_client_name
      metadata_client_version
      metadata_date
      metadata_user
      legacy_work_item
      pge_status
      pge_status_updated
      pge_work_date
      work_item_type
      legacy_item_id
      legacy_display_id
      created_date
      ticket
      ticket_id
      field_meet_scheduled_date
      pge_folder_id
      pge_division
      pge_region
      source_file_path
      worklogs {
        id
        doc_type
        ticket_id
        worklog_type
        long_description
        note
        start_time
        start_latitude
        start_longitude
        end_time
        end_latitude
        end_longitude
        response_type
        metadata_originating_user
        metadata_user
        form
        photos {
          is_legacy
          original
          original_download_url
          thumbnail_download_url
        }
      }
      parent {
        id
        printable_text
        pge_center_coords {
          coordinates
        }
        pge_polygon {
          coordinates
        }
      }
    }
  }
`;

export const FIELDMEET_ID_COORDINATES = gql`
  query getFieldMeetById($id: String!) {
    getFieldMeetById(id: $id) {
      doc_type
      id
      parent {
        id
        pge_center_coords {
          coordinates
        }
        pge_polygon {
          coordinates
        }
      }
    }
  }
`;

export const STANDBY_ID_DETAILS = gql`
  query getStandByById($id: String!) {
    getStandByById(id: $id) {
      doc_type
      id
      metadata_client_name
      metadata_client_version
      metadata_date
      metadata_user
      legacy_work_item
      pge_status
      pge_status_updated
      pge_work_date
      work_item_type
      legacy_item_id
      legacy_display_id
      created_date
      ticket
      ticket_id
      standby_scheduled_date
      field_meet_id
      pge_folder
      pge_folder_id
      pge_division
      pge_region
      source_file_path
      worklogs {
        id
        doc_type
        ticket_id
        worklog_type
        long_description
        note
        start_time
        start_latitude
        start_longitude
        end_time
        end_latitude
        end_longitude
        response_type
        metadata_originating_user
        metadata_user
        form
        photos {
          is_legacy
          original
          original_download_url
          thumbnail_download_url
        }
      }
      parent {
        id
        printable_text
        pge_center_coords {
          coordinates
        }
        pge_polygon {
          coordinates
        }
      }
    }
  }
`;

export const STANDBY_ID_COORDINATES = gql`
  query getStandByById($id: String!) {
    getStandByById(id: $id) {
      doc_type
      id
      parent {
        id
        pge_center_coords {
          coordinates
        }
        pge_polygon {
          coordinates
        }
      }
    }
  }
`;

export const POLYGON_SEARCH = gql`
  query polygonSearch(
    $dateRange: DateRangeQuery
    $pge_polygon: GeoJsonPolygonQuery
    $pge_status: String
    $workType: String
    $ticketType: String
    $excavatorName: String
    $locatedBy: String
  ) {
    polygonSearch(
      ticket: {
        dateRange: $dateRange
        pge_polygon: $pge_polygon
        pge_status: $pge_status
        work_type: $workType
        type: $ticketType
        excavator_name: $excavatorName
        located_by: $locatedBy
      }
    ) {
      id
      pge_center_coords {
        coordinates
      }
      priority
      doc_type
      done_for
      pge_address
      pge_folder
      pge_status
      pge_excavator
      pge_work_date
      pge_response_type
      metadata_originating_user
      work_type
      fieldMeets {
        id
      }
      standbys {
        id
      }
    }
  }
`;

export const GET_EMER = gql`
  query getOpenEmergencyTicketsV2 {
    getOpenEmergencyTicketsV2 {
      results {
        id
        pge_center_coords {
          coordinates
        }
        priority
        doc_type
        pge_address
        pge_status
        pge_excavator
        pge_work_date
        work_type
        fieldMeets {
          id
        }
        standbys {
          id
        }
      }
      unmappedResults {
        id
        pge_status
        priority
      }
    }
  }
`;

export const TICKET_TYPE_SUMMARY = gql`
  query ticketTypeSummary(
    $dateRange: DateRangeQuery
    $pge_status: String
    $callCenter: String
    $pgeRegCodes: [String]
  ) {
    ticketTypeSummary(
      ticket: {
        dateRange: $dateRange
        pge_status: $pge_status
        call_center: $callCenter
        pge_reg_codes: $pgeRegCodes
      }
    ) {
      center
      totals {
        total
        type
        pge_reg_code
      }
    }
  }
`;

//workLogDateRange - metadata_date (last modified)
//workLogStartRange
//workLogEndRange
export const GET_WORKLOGS_IN_DATE_RANGE = gql`
  query ($worklogStartRange: WorklogDateRangeQuery, $locatedBy: String) {
    worklogSearch(ticket: { worklogStartRange: $worklogStartRange, locator: $locatedBy }) {
      id
      locator
      metadata_date
      response_type
      adjusted_start
      start_time
      end_time
      ticket_id
      related_field_meet_id
      related_ticket_id
      standby_id
      field_meet_id
      worklog_type
    }
  }
`;

export const GET_USERS_LIST = gql`
  query GetUsersList {
    getUsersList {
      id
      lan_id
      first_name
      last_name
      middle_name
      suffix
      active
    }
  }
`;

export const GET_USER_BY_ID = gql`
  query GetUserById($id: String) {
    getUserById(id: $id) {
      id
      lan_id
      first_name
      middle_name
      last_name
      suffix
      active
    }
  }
`;

export const GET_STANDBY_INSPECTORS_LIST = gql`
  query GetStandbyInspectorsList {
    getStandbyInspectorsList {
      id
      user {
        id
        lan_id
        first_name
        middle_name
        last_name
        suffix
        active
      }
    }
  }
`;

export const GET_STANDBY_INSPECTOR_BY_ID = gql`
  query GetStandbyInspectorById($id: String!) {
    getStandbyInspectorById(id: $id) {
      id
      user {
        id
        lan_id
        first_name
        middle_name
        last_name
        suffix
        active
      }
    }
  }
`;

export const UserInput = {
  lan_id: String,
  last_name: String,
  first_name: String,
  middle_name: String,
  suffix: String,
  active: Boolean,
};

export const CREATE_STANDBY_INSPECTOR = gql`
  mutation CreateStandbyInspector($input: UserInput) {
    createStandbyInspector(input: $input) {
      id
    }
  }
`;

export const UPDATE_STANDBY_INSPECTOR = gql`
  mutation UpdateStandbyInspector($id: String, $user_id: String, $input: UserInput) {
    updateStandbyInspector(id: $id, user_id: $user_id, input: $input) {
      id
      user {
        id
        lan_id
        first_name
        middle_name
        last_name
        suffix
        active
      }
    }
  }
`;

export const DELETE_STANDBY_INSPECTOR = gql`
  mutation DeleteStandbyInspector($id: String) {
    deleteStandbyInspector(id: $id) {
      id
    }
  }
`;

// ── Operator Qualification Queries ──

const OQ_FIELDS = `
  id
  oq_id
  emp_name
  emp_lan_id
  sup_lan_id
  oq_start_dt_formatted
  oq_exp_dt_formatted
  division
  vendor
  data_source
  comments
  created_at_formatted
  updated_at_formatted
`;

export const GET_OQ_BY_SUP_LAN_ID = gql`
  query getOperatorQualificationsBySupLanId($supLanId: String!) {
    getOperatorQualificationsBySupLanId(supLanId: $supLanId) {
      ${OQ_FIELDS}
    }
  }
`;

export const GET_OQ_BY_LAN_ID = gql`
  query getOperatorQualificationsByLanId($lanId: String!) {
    getOperatorQualificationsByLanId(lanId: $lanId) {
      ${OQ_FIELDS}
    }
  }
`;

export const GET_OQ_LIST = gql`
  query getOperatorQualificationsList($page: Int, $limit: Int) {
    getOperatorQualificationsList(page: $page, limit: $limit) {
      nextPage
      data {
        ${OQ_FIELDS}
      }
    }
  }
`;

export const UPSERT_OPERATOR_QUALIFICATIONS = gql`
  mutation UpsertOperatorQualifications(
    $input: [OperatorQualificationInput]
    $data_source: String
    $last_edited_by: String
  ) {
    upsertOperatorQualifications(
      input: $input
      data_source: $data_source
      last_edited_by: $last_edited_by
    ) {
      id
      oq_id
      emp_name
      emp_lan_id
      sup_lan_id
      oq_start_dt
      oq_exp_dt
      division
      vendor
      data_source
      comments
      api_success
      api_response_msgs
    }
  }
`;

export const DELETE_OPERATOR_QUALIFICATION = gql`
  mutation DeleteOperatorQualification($id: String) {
    deleteOperatorQualification(id: $id) {
      id
    }
  }
`;
